import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Shared page title + subtitle used across redesigned app pages.
 */
export default function PageHeader({ title, subtitle, actions, className, eyebrow }) {
  return (
    <div className={cn('flex items-start justify-between mb-7 gap-4', className)}>
      <div>
        {eyebrow ? (
          <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-spacepurple mb-2">{eyebrow}</p>
        ) : null}
        <h1 className="font-display text-[26px] leading-8 font-bold text-ink mb-1.5 tracking-tight">{title}</h1>
        {subtitle ? <p className="text-sm text-mute">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex-shrink-0">{actions}</div> : null}
    </div>
  );
}
